import xs from "xstream"
import {div, br, label, a, button, span, table, thead, tbody, tfoot, tr, th, td} from "@cycle/dom"
import * as R from "ramda"
import { isDemoUser } from "../../common";

const PDF_ID = "399";
const hasPdf = pdf => (pdf && R.propEq(PDF_ID, "id", pdf))

// MEMBER ID DEMO
const DEMO_IDS = ["9920133", "0010087", "9910067"]

const EVENT_ID = "6"
const PAY_LOG_ID = 30
const hasPayment = log => (log && R.propEq(EVENT_ID, "eventId", log) && R.propEq(PAY_LOG_ID, "actionId", log))

const creditView = credit => {
  const date = R.prop("date", credit)
  const name = R.propOr("-", "name", credit)
	const creditDate = date ? date : div(".abscent",["未受講"])
	return tr([
		td([name]),
		td({attrs: {style: "text-align: center"}}, [creditDate])
	])
}
const pointView = point => {
  const _point = R.prop("point", point)
	const pointDesc = _point === 0 ? "-" : _point
	return tr(".pointRow", [
		td([R.prop("date", point)]),
		td([R.prop("kaisai", point), R.prop("name", point)]),
		td({attrs: {style: "text-align: center"}}, [pointDesc])
	])
}
const downloadView = pdf => {
	if (hasPdf(pdf)) {
		return tr([
			td([R.prop("date", pdf)]),
			td([
				"2018年度第2回生殖医療従事者講習会Web講習",
				span(".badge.badge-danger.jsrm63", {attrs:{["data-id"]: R.prop("id", pdf)}},["PDF"]),
				span(".badge.badge-success", {attrs:{["data-slide"]: 100001}}, ["Web講習会スライド"]),
				div(".msg", ["※スライドのダウンロードおよび印刷はできません。"])
				// span(".badge.badge-success", {attrs:{[`data-slide`]: 100002}}, ["スライド2"])
			]),
		])
	}
	return tr(".downloadRow", {attrs:{["data-id"]: R.prop("id", pdf)}}, [
		td([R.prop("date", pdf)]),
		td([R.prop("kaisai", pdf),R.prop("name", pdf), span(".badge.badge-danger",["PDF"])]),
	])
}

export const view = (user$, points$, credits$, pdfEvents$, logs$) =>
	xs.combine(user$, points$, credits$, pdfEvents$, logs$)
	.map(([user, points, credits, pdfEvents, logs]:[any, any, any, any, any]) => {
		// const member = user.get("members", List()).find(m => m.get("type") === 10)
    if (!user) {
      return null
    }
    const members = R.propOr([], "members", user)
		const member = R.find(R.propEq(10, "type"))(members)
		// const member2 = user.get("members", List()).find(m => m.get("type") !== 10)
		const member2 = R.find(R.compose(R.not, R.propEq(10, "type")))(members)
		const memo = JSON.parse(R.propOr("{}", "memo", member2))
		const senmon = member2 ? R.propOr("", "nendo", memo) : null
		const senmonId = R.propEq("停止", "idou")(memo) ? "停止" : R.prop("id", member2)

		const pdfs = R.reject(R.isNil, R.map(pts => {
			const eventId = R.prop("id", pts)
			const event = R.find(R.propEq(eventId, "id"), pdfEvents)
			return event ? pts : null
		})(points))

		const sum = (sum, pt) => sum + R.propOr(0, "point", pt)
		const totalPoints = R.reduce(sum, 0)(points)

		/** 第2回対応 */
		const pdfs2 = ((_pdfs: any) => {
			/* IF SET ALREADY JUST RETURN ORIGINAL PDFS */
			const dai2Pdf  =  R.find(hasPdf)(_pdfs)
			if (dai2Pdf) {
				return _pdfs;
			}
			/* FIND IF MEMBER HAS PAID FOR DAI2 */
			const payLogFor2 = R.find(hasPayment)(logs)
			if (!payLogFor2) {
				return _pdfs;
			}
			return R.append({id: PDF_ID, date: '2018/11/09'}, _pdfs)
		})(pdfs)
		// MEMBER ID DEMO
		// const doDemo = isDemoUser(user.get("id"))
		return div(".panel-body.panel-primary",[
			div(".pointView", [
				div(".topPanel", [
					label(["【会員情報】"]),
					// doDemo ? null : button(".btn.btn-danger.btnPassword", ["パスワード変更"]),
					// doDemo ? null : button(".btn.btn-success.btnLogout", ["ログアウト"]),
					// doDemo ? button(".btn.btn-success.btnReturn", ["戻る"]) : null,
					button(".btn.btn-success.btnReturn", ["戻る"]),
				]),
				table(".table.table-responsive.table-condensed.memberInfo",[
					tbody([
						tr([
							th(".bg-primary", ["会員番号"]),
							td([R.prop("id", member)]),
						]),
						tr([
							th(".bg-primary", ["お名前"]),
							td([R.prop("lastName", user),"　", R.prop("firstName", user)]),
						]),
						member2	
							? tr([
								th(".bg-primary", ["専門医番号"]),
								td([senmonId]),
							])
							: null,
						senmon	
							? tr([
								th(".bg-primary", ["認定年度"]),
								td([senmon,"年度認定"]),
							])
							: null,
						senmon	
							? tr([
								th(".bg-primary", ["専門医ポイント"]),
								td([totalPoints, "ポイント"]),
							])
							: null,
					])
				]),

				div([
          div(".labelWithMessage", [
            label(["【生殖医療専門医・専攻医取得単位】"]),
			div([
				div(".msg", ["※取得日欄に受講日時の記載がある単位は受講済です"]),
				div(".msg", ["※今年度受講分単位は配信期間終了後に反映されます"]),
			]),
          ]),
					table(".table.table-responsive.table-condensed.creditLog",[
						thead([
							tr(".bg-primary", [
								th(["単位項目名"]),
								th({attrs: {style:"width: 132px; text-align:center"}}, ["取得日"])
							])
						]),
						tbody(R.map(creditView, credits))
					])
				]),
				div([
					label(["【学会講習会参加状況】"]),
					table(".table.table-responsive.table-condensed.pointLog",[
						thead([
							tr(".bg-primary", [
								th(["実施日"]),
								th(["名称"]),
								th({attrs: {style:"width: 132px"}}, ["合計", " ", totalPoints, "ポイント"])
							])
						]),
						tbody(".resultBody", R.reverse(R.map(pointView, points))),
					])
				]),
				div([
					div(".labelWithMessage", [
						label(["【生殖医療従事者講習会　受講証ダウンロード】"]),
						div([
							div(".msg", ["※実開催の講習会のみ受講証が発行されます。e-learningの講習会は受講証の発行はございません"]),
						]),
					  ]),
					table(".table.table-responsive.table-condensed.pdfDownload.table-hover",[
						thead([
							tr(".bg-primary", [
								th(["実施日"]),
								th(["名称"]),
							])
						]),
						tbody(".resultBody", R.reverse(R.map(downloadView, pdfs2))),
					])
				]),
			])
		])
	})
